import type { CommandPaletteGroup } from '@nuxt/ui'

export const useGlobalShortcuts = createSharedComposable(() => {
  const viewShortcutsHook = createEventHook()
  const agentChatOpen = useLocalStorage('@admin/agent-chat-open', false)
  const chatAvailable = useChatAvailable()

  const GENERAL_SHORTCUTS = computed(() => [
    {
      label: 'View keyboard shortcuts',
      icon: 'i-lucide-keyboard',
      kbds: ['meta', '/'],
      onSelect() {
        viewShortcutsHook.trigger()
      },
    },
    ...(chatAvailable.value
      ? [
          {
            label: 'Toggle agent chat',
            icon: 'i-ph-sparkle',
            kbds: ['meta', 'J'],
            onSelect() {
              agentChatOpen.value = !agentChatOpen.value
            },
          },
        ]
      : []),
    {
      label: 'Log out',
      icon: 'i-lucide-log-out',
      to: '/logout',
      kbds: ['meta', 'shift', 'Q'],
      onSelect() {
        navigateTo('/logout')
      },
    },
  ])

  const TOP_MENU_NAV_ITEMS = [
    {
      label: 'Dashboard',
      icon: 'i-lucide-house',
      to: '/dashboard',
      kbds: ['G', 'D'],
      onSelect() {
        navigateTo('/dashboard')
      },
    },
    {
      label: 'Policy Studio',
      icon: 'i-ph-pen-nib',
      to: '/policy-studio',
      kbds: ['G', 'C'],
      onSelect() {
        navigateTo('/policy-studio')
      },
    },
    {
      label: 'Settings',
      icon: 'i-lucide-settings',
      to: '/settings',
      kbds: ['G', 'S'],
      onSelect() {
        navigateTo('/settings')
      },
    },
  ]

  const NAVIGATION_SHORTCUTS = [...TOP_MENU_NAV_ITEMS]

  defineShortcuts(
    computed(() => ({
      ...extractShortcuts(GENERAL_SHORTCUTS.value),
      ...extractShortcuts(NAVIGATION_SHORTCUTS, '-'),
    })),
  )

  return {
    all: computed(
      () =>
        [
          {
            id: 'general',
            label: 'General',
            items: GENERAL_SHORTCUTS.value,
          },
          {
            id: 'navigation',
            label: 'Navigation',
            items: NAVIGATION_SHORTCUTS,
          },
        ] satisfies CommandPaletteGroup[],
    ),
    navigation: NAVIGATION_SHORTCUTS,
    topMenuItems: TOP_MENU_NAV_ITEMS,
    general: GENERAL_SHORTCUTS,
    onViewShortcuts: viewShortcutsHook.on,
  }
})
